import * as React from 'react'
import { useUserDocuments } from '@features/userDocuments'
import { Button } from '@shared/components/button'
import { Checkbox } from '@shared/components/checkbox'
import { SignFormCard } from '@shared/components/forms/sign/components/card'
import { FormikProvider } from 'formik'

import { useSignForm } from '../../..'

import { IStateProps } from './model'

import styles from './styles.module.scss'

export const View = ({ formik }: IStateProps) => {
	const { documentsList, getPdfDataUri, fetchDocumentsList } = useUserDocuments()!
	const { toggleSpoiler } = useSignForm()

	React.useEffect(() => {
		;(async () => {
			const data = await fetchDocumentsList()

			if (data)
				data.filter(({ required }) => !required).forEach(({ id }) => formik.setFieldValue(id, true))
		})()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchDocumentsList])

	const notRequiredDocs = documentsList.filter(({ required }) => !required)

	return (
		<FormikProvider value={formik}>
			<SignFormCard onToggleSpoiler={toggleSpoiler}>
				<form onSubmit={formik.handleSubmit}>
					{!!documentsList.length && (
						<>
							Нажимая кнопку «Далее», я даю своё согласие и подтверждаю, что ознакомился со
							следующим списком документов: <br />
							{documentsList.map(({ name, id }, i) => (
								<div key={id}>
									{i + 1}.{' '}
									<a
										className='main-link'
										target='_blank'
										rel='noopener noreferrer nofollow'
										href={getPdfDataUri(id)}
									>
										{name}
									</a>
									.
								</div>
							))}
							{!!notRequiredDocs.length && (
								<div className={styles.grid}>
									{notRequiredDocs.map(({ id, description }) => (
										<Checkbox key={id} name={id} label={description} />
									))}
								</div>
							)}
						</>
					)}
					<Button
						type='submit'
						className={styles.submitButton}
						disabled={
							(!!notRequiredDocs.length && !Object.keys(formik.values).length) ||
							formik.isSubmitting
						}
					>
						Далее
					</Button>
				</form>
			</SignFormCard>
		</FormikProvider>
	)
}
